import { render } from "./bankLevel.vue?vue&type=template&id=33a18cde&scoped=true"
import script from "./bankLevel.vue?vue&type=script&lang=js"
export * from "./bankLevel.vue?vue&type=script&lang=js"

import "./bankLevel.vue?vue&type=style&index=0&id=33a18cde&scoped=true&lang=css"

import exportComponent from "/Users/cole/.codex/worktrees/jwt-cookie-expiry/tcd-cube_opr/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33a18cde"]])

export default __exports__